export const SnackBarActionType = {
    OPEN_SNACK_BAR: "OPEN_SNACK_BAR",
    CLOSE_SNACK_BAR: "CLOSE_SNACK_BAR"
}